/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M5 12l14 0", "key": "svg-0" }]];
const IconMinus = createReactComponent("outline", "minus", "Minus", __iconNode);

export { __iconNode, IconMinus as default };
//# sourceMappingURL=IconMinus.mjs.map
